import { render, staticRenderFns } from "./anonymous-feedback-form.vue?vue&type=template&id=e274f9c0&scoped=true"
import script from "./anonymous-feedback-form.vue?vue&type=script&lang=js"
export * from "./anonymous-feedback-form.vue?vue&type=script&lang=js"
import style0 from "./anonymous-feedback-form.vue?vue&type=style&index=0&id=e274f9c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e274f9c0",
  null
  
)

export default component.exports